import {  Form, Input } from "antd";
import React from "react";

const AssureLastNameField=({disable})=> {
    return (
        <React.Fragment>
            <Form.Item
                label="Prenom"
                name="assureLastname"
                rules={[{ required: true, message: "Champ obligatoire" }]}
            >
                <Input size='large' placeholder='Prenom' disabled={disable} />
            </Form.Item>
        </React.Fragment>
    )
}

export default AssureLastNameField;